import { render } from "./SetSplitTemplate.vue?vue&type=template&id=21d507b2&scoped=true"
import script from "./SetSplitTemplate.vue?vue&type=script&lang=js"
export * from "./SetSplitTemplate.vue?vue&type=script&lang=js"

import "./SetSplitTemplate.vue?vue&type=style&index=0&id=21d507b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d507b2"]])

export default __exports__